const _ = require('lodash'), TimingEvent = require('./timing-event');

/**
 * Takes measurements created using the User Timing api and
 * pushes them to atm for analysis.
 * @constructor
 * @param {object} atm
 * @returns {PerformanceMeasurer}
 */
function PerformanceMeasurer(features, atm) {
    this.features = features;
    this.atm = atm;
}

/**
 * Create a start performance mark.
 * @param {string} name
 * @returns {}
 */
PerformanceMeasurer.prototype.startMeasure = function (name) {
    if (!name) {
        throw new Error('Must provide a measure name.');
    }

    performance.mark(name + ':start');
};

/**
 * Create an end performance mark and measure time taken. Pushes the measure to Google Analytics as a side effect.
 * @param {string} name - The name of the measure.
 * @returns {PerformanceMeasure[]}
 */
PerformanceMeasurer.prototype.endMeasure = function (name) {
    if (!name) {
        throw new Error('Must provide a measure name.');
    }

    performance.mark(name + ':end');
    const measures = this.measure(name);
    if (measures.length) {
        this.pushTimingEventsToatm(_.map(measures, TimingEvent));

        performance.clearMeasures();
    }

    return measures;
};

/**
 * Measures the time different between start and end marks and clears marks which are measured.
 * @param {string} name - The name of the measure.
 * @returns {PerformanceMeasure[]}
 */
PerformanceMeasurer.prototype.measure = function (name) {
    if (!name) {
        throw new Error('Must provide a measure name.');
    }
    const startMarkName = name + ':start';
    const endMarkName = name + ':end';
    try {
        performance.measure(name, startMarkName, endMarkName);

        performance.clearMarks(startMarkName);
        performance.clearMarks(endMarkName);
    } catch (e) {
        // probably there isn't a start and end mark. ignore this
    }

    return performance.getEntriesByName(name, 'measure');
};

/**
 * Pushes timing events to atm.
 * @param {TimingEvent[]} timingEvents
 */
PerformanceMeasurer.prototype.pushTimingEventsToatm = function (timingEvents) {
    if (!this.features.isEnabled(this.features.features.diagnostics)) {
        return;
    }

    _.forEach(timingEvents, function (timingEvent) {
        this.atm.push({ event: 'timingEvent', timing: { category: timingEvent.category, var: timingEvent.var, value: timingEvent.value, label: timingEvent.label } });
    }, this);
};

module.exports = PerformanceMeasurer;


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/performance/performance-measurer-service.js
 **/